import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const getFamilyMembersSlice = createSlice({
  name: 'getFamilyMembers',
  initialState,
  reducers: {
    getFamilyMembersRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    getFamilyMembersSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    getFamilyMembersFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    getFamilyMembersReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const getFamilyMembersAction = getFamilyMembersSlice.actions;
export default getFamilyMembersSlice;